<template>
  <categories-detail :is-edit='false'>
  </categories-detail>
</template>

<script>
import CategoriesDetail from '../components/CategoriesDetail'
export default {
  name: 'CreateCategories',
  components: {
    CategoriesDetail
  }
}
</script>

